import * as React from "react";
import type { SVGProps } from "react";
const SvgAtlanticAirways = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 50 50"
    width="100%"
    height="100%"
    {...props}
  >
    <clipPath id="atlantic-airways_svg__a">
      <path d="M0 0h50v50H0z" />
    </clipPath>
    <g
      fillRule="evenodd"
      clipPath="url(#atlantic-airways_svg__a)"
      clipRule="evenodd"
    >
      <path
        fill="#00529b"
        d="M17.544 27.553s-4.503-2.057-4.417-3.183a.45.45 0 0 1 .176-.308s2.346-2.585 6.893-4.405c3.67-1.472 4.537-1.37 4.537-1.37-.063 1.684 1.027 3.011 2.778 3.624 0 0 6.878-2.192 10.76-2.505 4.684-.38 6.385 1.365 6.385 1.365s3.894.224 5.185 1.022c0 0 .166.131.159.2-.003.023-.024.035-.078.035-.215.004-.932-.153-1.975-.04-2.494.267-6.992.82-8.32 1.557 0 0-7.216 11.44-39.627 11.275 0 0 10.03-2.186 17.544-7.267"
      />
      <path
        fill="#df3127"
        d="M25.368 16.352c.286-.016.96.099 1.102.485 0 0-1.053-.633-14.373 3.597C7.922 21.757 1.627 17.371.015 16c0 0 5.037 1.326 25.353.35"
      />
    </g>
  </svg>
);
export default SvgAtlanticAirways;
